import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { DIET_QUERY } from '../graphql/queries'
import { FETCH_DIET } from '../redux/action-types'
import { cleanupFetchDiet } from '../redux/actions'

const useDietQuery = id => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchDiet)

  const { isFetchLoading, fetchError, data } = useSelector(
    store => store.diets.diet,
  )

  const refetch = useCallback(
    id => apolloService.query(DIET_QUERY, { id }, dispatch, FETCH_DIET),

    [dispatch],
  )

  useEffect(() => {
    refetch(id)
  }, [id, refetch])

  return { isLoading: isFetchLoading, error: fetchError, data, refetch }
}

export default useDietQuery
